import React from "react"
import { Link } from "gatsby"
import styles from "./ImageGallery.module.scss"

const ImageWrapper = ({ caption, children }) => {
  if (!caption) return <>{children}</>
  const link = caption[0].markDefs.find((element) => element._type === "link")

  const slug = link && link.page && link.page.slug && link.page.slug.current
  if (link) {
    return link.href ? (
      <a href={link.href} className={styles.imageWrapper}>
        {children}
      </a>
    ) : (
      <Link to={slug} className={styles.imageWrapper}>
        {children}
      </Link>
    )
  } else {
    return <>{children}</>
  }
}

export default ImageWrapper
